import ajax from '../utils/ajax'

function getPhotoUrl(photo) {
  return photo.length > 2 ? `http://img.draugas.lt/nuotraukos/dideles/${photo.substring(0, 2)}/${photo}` : ''
}

export default class QuestionGame {

  static trackClick(text, callback) {
    ajax({
      url: '/dotnet/question/WebService.asmx/TrackClick',
      data: JSON.stringify({text: text}),
      success: function() {
        typeof callback === 'function' && callback();
      }
    })
  }

  static voteBack(gameType, id, yes, callback) {

    ajax({
      url: `/dotnet/question/WebService.asmx/${yes ? 'PositiveVote' : 'HideVoter'}`,
      data: JSON.stringify(yes ? {ValentineId: id, GameType: gameType} : {VoterId: id}),
      success: function() {
        typeof callback === 'function' && callback();
      }
    })
  }

  static uncover(id, online, callback) {

    ajax({
      url: '/dotnet/question/WebService.asmx/GetPhoto',
      data: JSON.stringify({UserId: id, online: online}),
      success: function(response) {

        const resp = response.d

        if (resp != null) {
          var image = new Image()

              image.onload = function() {

              typeof callback === 'function' && callback({

                success: true,
                valentine: {
                  id: resp.UserId,
                  name: resp.Name,
                  age: resp.Age,
                  photo: resp.Photo,
                  city: resp.City,
                  hiddenId: id,
                  hidden: false
                },
                freePoints: {
                  disabled: resp.Disabled,
                  votesLeft: resp.VotesLeftUntilReward,
                  count: resp.FreePoints
                },
                credits: resp.Coins
            })
          }

          image.src = resp.Photo

        }
        else {

          typeof callback === 'function' && callback({
            success: false
          })
        }
      }
    })
  }

  static vote(gameType, id, yes, ageFrom, ageTo, callback) {

    ajax({
      url: '/dotnet/Question/WebService.asmx/Vote',
      data: JSON.stringify({
        ValentineId: id,
        Vote: yes ? 1 : 0,
        AgeFrom: ageFrom,
        AgeTo: ageTo,
        Source: 1,
        GameType: gameType
      }),
      success: function (response) {

        var photo = getPhotoUrl(response.d.Photo);

        var image = new Image()
        image.onload = function() {
          typeof callback === 'function' && callback({
            valentine: {
              id: response.d.UserId,
              name: response.d.Name,
              age: response.d.Age,
              photo: photo,
              city: response.d.City,
              photoCount: response.d.PhotoCount
            },
            freePoints: {
              disabled: response.d.FreePointsDisabled,
              votesLeft: response.d.VotesUntilReward,
              count: response.d.FreePoints
            },
            credits: response.d.Credits,
            mutualDesire: response.d.Mutual
          })
        }

        image.src = photo
      }
    })
  }
}